/* REST API */
import { cities, categories } from '../api/Ref'
import { list } from '../api/Favourite'

export const actionData = store => {

    Promise.all([cities(), categories()]).then(([resCities, resCategories]) => {

        const list = resCities && resCities.status === 200 ? resCities.data : []

        store.dispatch({
            type: 'SET_DATA',
            payload: {
                cities: list,
                categories: resCategories && resCategories.status === 200 ? resCategories.data : []
            }
        })

        /* Default city — Almaty (or the first available) when none is selected yet */
        if (!store.getState().city && list.length) {
            const almaty = list.find(item => /алмат/i.test(item.name)) || list[0]
            store.dispatch({ type: 'SET_CITY', payload: almaty })
        }
    })
}

export const actionFavourites = store => {

    const token = localStorage.getItem("token")
    if (!token) {
        return
    }

    /* The backend rejects an expired/invalid token itself — no need to gate here */
    list(token).then(response => {
        if (response && response.status === 200 && Array.isArray(response.data)) {
            store.dispatch({
                type: 'INIT_FAVOURITE',
                payload: response.data
            })
        }
    })
}
